/* RUMBO — interacciones propias (prefijo rb-) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.rb-reveal:not(.rb-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var marcos = document.querySelectorAll('[data-rb-parallax]');
    if (!marcos.length || reduceMotion) return;
    var ticking = false;
    function update() {
      marcos.forEach(function (m) {
        var fuerza = parseFloat(m.getAttribute('data-rb-parallax')) || 0;
        var r = m.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        m.style.transform = 'translate3d(0,' + (centro * -fuerza / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCarruseles() {
    document.querySelectorAll('[data-rb-carrusel]').forEach(function (c) {
      if (c.dataset.rbListo) return;
      c.dataset.rbListo = '1';
      var pista = c.querySelector('.rb-estampados__pista');
      if (!pista) return;
      c.querySelectorAll('[data-rb-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var item = pista.firstElementChild;
          var paso = item ? item.getBoundingClientRect().width + 18 : 300;
          pista.scrollBy({ left: paso * parseInt(b.dataset.rbDir, 10), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function initPasos() {
    document.querySelectorAll('[data-rb-pasos]').forEach(function (s) {
      var pasos = s.querySelectorAll('.rb-paso');
      var imgs = s.querySelectorAll('.rb-pasos__marco img');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('rb-activo', i === j); });
        imgs.forEach(function (im, j) { im.classList.toggle('rb-activa', i === j); });
      }
      activar(0);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  function formatMoney(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var sinDecimales = Math.round(cents / 100).toString();
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDecimales)
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto() {
    document.querySelectorAll('[data-rb-producto]').forEach(function (raiz) {
      if (raiz.dataset.rbListo) return;
      raiz.dataset.rbListo = '1';
      var datosEl = raiz.querySelector('[data-rb-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var formato = raiz.getAttribute('data-rb-formato');
      var principal = raiz.querySelector('.rb-galeria__principal img');
      var minis = raiz.querySelectorAll('.rb-galeria__mini');
      var form = raiz.querySelector('form[data-rb-form]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = raiz.querySelector('.rb-compra__boton');
      var textoBoton = boton ? boton.querySelector('span') : null;
      var precioEl = raiz.querySelector('[data-rb-precio]');
      var antesEl = raiz.querySelector('[data-rb-antes]');
      var ahorroEl = raiz.querySelector('[data-rb-ahorro]');
      var errorEl = raiz.querySelector('.rb-compra__error');
      var barra = document.querySelector('[data-rb-barra]');

      function mostrarFoto(src, srcset, mediaId) {
        if (!principal || !src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach(function (m) { m.classList.toggle('rb-activa', m.dataset.mediaId === String(mediaId)); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrarFoto(m.dataset.src, m.dataset.srcset, m.dataset.mediaId); });
      });

      function actual() {
        var sel = [];
        raiz.querySelectorAll('[data-rb-opcion]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        return variantes.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }

      function actualizar(ev) {
        var v = actual();
        // Si la combinación no existe, elige la primera variante con el valor que se acaba de marcar
        if (!v && ev && ev.target) {
          var grupos = raiz.querySelectorAll('[data-rb-opcion]');
          var idx = Array.prototype.indexOf.call(grupos, ev.target.closest('[data-rb-opcion]'));
          var alt = variantes.find(function (x) { return x.available && x.options[idx] === ev.target.value; }) ||
                    variantes.find(function (x) { return x.options[idx] === ev.target.value; });
          if (alt) {
            grupos.forEach(function (g, i) {
              g.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === alt.options[i]; });
            });
            v = alt;
          }
        }
        if (!v || !inputId) {
          if (boton) { boton.disabled = true; if (textoBoton) textoBoton.textContent = boton.dataset.noDisponible; }
          return;
        }
        inputId.value = v.id;
        if (precioEl) precioEl.textContent = formatMoney(v.price, formato);
        var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
        if (antesEl) { antesEl.hidden = !hayAntes; if (hayAntes) antesEl.textContent = formatMoney(v.compare_at_price, formato); }
        if (ahorroEl) { ahorroEl.hidden = !hayAntes; if (hayAntes) ahorroEl.textContent = ahorroEl.dataset.prefijo + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) {
          boton.disabled = !v.available;
          if (textoBoton) textoBoton.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
        }
        raiz.querySelectorAll('[data-rb-valor-sel]').forEach(function (s, i) { s.textContent = v.options[i] || ''; });
        if (v.featured_media) {
          var mini = raiz.querySelector('.rb-galeria__mini[data-media-id="' + v.featured_media.id + '"]');
          if (mini) mostrarFoto(mini.dataset.src, mini.dataset.srcset, mini.dataset.mediaId);
        }
        if (barra) { var p = barra.querySelector('[data-rb-barra-precio]'); if (p) p.textContent = formatMoney(v.price, formato); }
        if (raiz.dataset.rbUrl && window.history.replaceState) {
          window.history.replaceState({}, '', raiz.dataset.rbUrl + '?variant=' + v.id);
        }
      }
      raiz.querySelectorAll('[data-rb-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      raiz.querySelectorAll('[data-rb-cantidad]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = raiz.querySelector('input[name="quantity"]');
          if (!inp) return;
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.rbCantidad, 10));
        });
      });

      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          var notif = document.querySelector('cart-notification');
          var carrito = drawer || notif;
          if (!carrito || typeof carrito.renderContents !== 'function' || !window.fetch) return;
          ev.preventDefault();
          if (errorEl) errorEl.hidden = true;
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          var secciones = carrito.getSectionsToRender().map(function (s) { return s.id; });
          fd.append('sections', secciones);
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) {
              if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; }
              return;
            }
            if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            carrito.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { boton.removeAttribute('aria-busy'); actualizar(); });
        });
      }

      if (barra) {
        var objetivo = raiz.querySelector('.rb-compra__fila');
        if (objetivo && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { barra.classList.toggle('rb-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
          }).observe(objetivo);
        }
        var irBtn = barra.querySelector('[data-rb-barra-ir]');
        if (irBtn) irBtn.addEventListener('click', function () { boton.click(); });
      }
    });
  }

  function initPestanas() {
    document.querySelectorAll('[data-rb-pestanas]').forEach(function (s) {
      if (s.dataset.rbListo) return;
      s.dataset.rbListo = '1';
      var tabs = s.querySelectorAll('[data-rb-tab]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var activa = o === t;
            o.classList.toggle('rb-activa', activa);
            o.setAttribute('aria-selected', activa ? 'true' : 'false');
            var panel = document.getElementById(o.dataset.rbTab);
            if (!panel) return;
            panel.hidden = !activa;
            if (activa) {
              panel.querySelectorAll('.rb-reveal').forEach(function (e) { e.classList.add('rb-visible'); });
              panel.classList.remove('rb-entrando'); void panel.offsetWidth; panel.classList.add('rb-entrando');
            }
          });
        });
      });
    });
  }

  function init(root) {
    initReveals(root);
    initCarruseles();
    initPasos();
    initPestanas();
    initProducto();
  }

  document.addEventListener('DOMContentLoaded', function () { init(); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
